import { render } from "./CustomerImportModal.vue?vue&type=template&id=109ffb2b&scoped=true"
import script from "./CustomerImportModal.vue?vue&type=script&lang=js"
export * from "./CustomerImportModal.vue?vue&type=script&lang=js"

import "./CustomerImportModal.vue?vue&type=style&index=0&id=109ffb2b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109ffb2b"]])

export default __exports__